const uniqueStrings = (list: Array<string>) => {
  return Array.from(new Set(list));
};

export { uniqueStrings };
